import {FC, createRef, useEffect, useRef} from 'react';
import styles from "@/styles/Ui.module.scss"
import clsx from "clsx";


interface Props {
    src: string,
    alt: string,
    className?:string
    onClick?():void
}


const LazyImage: FC<Props>  = ({src, alt, className, onClick}) => {
    const img:any = createRef();
    const effect_ran = useRef<boolean>(false)
    
    const imgLoad = (img:any) => {
        
        img.setAttribute('src', src);
        img.setAttribute('alt', alt);
        
        if (img.complete) {
            img.parentNode.classList.add(styles.loaded);
        } else {
            img.onload = function() {
                img.parentNode.classList.add(styles.loaded);
            };
        }
    };
    
    const imgObserver = () => {
        if (!img.current) return;
        
        if (typeof window !== "undefined") {
            const isSamsungBrowser = navigator.userAgent.match(/SamsungBrowser/i);
            
            if ('IntersectionObserver' in window && !isSamsungBrowser) {
                const io = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            imgLoad(entry.target);
                            
                            observer.disconnect();
                        }
                    });
                });
                
                io.observe(img.current)
                
            } else {
                if (img.current) {
                    imgLoad(img.current);
                }
            }
        }
    };
    
    useEffect(() => {
        if(!effect_ran.current) {
            imgObserver();
        }
        
        return () => {
            effect_ran.current = true
        }
        
    }, []);
    
    
    
    return (
        <div
            onClick={() => {
                if(typeof onClick === "function") {
                    onClick()
                }
            }}
            className={clsx(styles.lazy_game_thumb, className)}
        >
            <div className={styles.lazy_game_thumb__preview}/>
            <img
                ref={img}
                // width={width && width}
                // height={height && width}
                alt={alt}
                src={src}
            />
        </div>
    )
}

export default LazyImage